import { email, required, useGetIdentity, useRecordContext } from "ra-core";
import { BooleanInput } from "@/components/admin/boolean-input";
import { TextInput } from "@/components/admin/text-input";
import { AutocompleteArrayInput } from "@/components/admin/autocomplete-array-input";

import type { Sale } from "../types";

const ROLE_CHOICES = [
  { id: "sales", name: "Sales" },
  { id: "purchasing", name: "Purchasing" },
  { id: "logistics", name: "Logistics" },
  { id: "accounting", name: "Accounting" },
  { id: "ar", name: "AR" },
  { id: "ap", name: "AP" },
  { id: "workflow_manager", name: "Workflow Manager" },
  { id: "auditor", name: "Auditor" },
  { id: "special_duplicate", name: "Special Duplicate" },
];

export function SalesInputs() {
  const { identity } = useGetIdentity();
  const record = useRecordContext<Sale>();
  return (
    <div className="space-y-4 w-full">
      <TextInput source="first_name" validate={required()} helperText={false} />
      <TextInput source="last_name" validate={required()} helperText={false} />
      <TextInput
        source="email"
        validate={[required(), email()]}
        helperText={false}
      />
      <AutocompleteArrayInput
        source="roles"
        choices={ROLE_CHOICES}
        placeholder="Add a role..."
        helperText={false}
      />
      <BooleanInput
        source="administrator"
        readOnly={record?.id === identity?.id}
        helperText={false}
      />
      <BooleanInput
        source="disabled"
        readOnly={record?.id === identity?.id}
        helperText={false}
      />
    </div>
  );
}
